module.exports = __webpack_public_path__ + "img/63.4151a28e.jpeg";